#!/usr/bin/env node
import * as app from "./tsviz-cli";
app.run();